module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"precachePages":["`/profile","/login"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#68A691","showSpinner":true},
    },{
      plugin: require('../node_modules/gatsby-source-prismic-graphql/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"hackersent","accessToken":"MC5YcVI0bmhFQUFDSUFhbHVo.XQXvv71eX--_vUfvv73vv71V77-977-977-977-977-977-977-9ShPvv71jUngE77-977-977-9Fe-_ve-_ve-_vWk","path":"/preview","previews":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hackersent","short_name":"hackersent","start_url":"/","background_color":"#2C1320","theme_color":"#5F4B66","display":"minimal-ui"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
